export class RoutePaths
{
	static SIGN_IN = '/sign-in';
	static SIGN_IN_TO_PORTAL = '/sign-in-to-portal';
	static PASS_SETUP = '/password-setup';
	static SSO_SIGN_IN = '/sign-in-with-sso';
	static PASS_RESTORE = '/password-restore';
	static SIGN_IN_NOTICES = '/sign-in-notices-showing';
}
